import React from 'react';
import { connect } from 'react-redux';
import { Spacer } from '@zillow/constellation';

import ListingTour from 'app/shared/components/postingPath/ListingTour';
import ListingStatus from 'app/shared/components/postingPath/ListingStatus';
import FloorplansMF from 'app/shared/components/postingPath/FloorplansMF';
import UnitsSection from 'app/shared/components/postingPath/UnitsSection';
import userUtils from 'app/shared/utils/userUtils';
import { AppSelectors, UserSelectors } from 'app/shared/selectors';
import { StyledHR } from 'app/shared/styledComponents';

const NotViewableContent = ({
    errorObj,
    formData,
    getActiveFloorplanOrUnitCount,
    isAddingUnit,
    isArchived,
    isListingPhotoProcessing,
    isScreenSM,
    isScreenXS,
    listing,
    saveFloorplanData,
    updateErrorObj,
    updateFormData,
    updateListingPhotoProcessingStatus,
    updateParentFloorplanPrice,
    updateOnFocus,
    updateStatusMessage,
    userRoles,
    user,
    validateFloorplan,
    validateFloorplans,
    validateUnit,
    cityStateZip,
    address,
}) => {
    const { features: { canUpdateListing } } = user;
    const {
        isFeed,
        syndication,
        isCommunity,
        restrictions: {
            isUpdateListingRestricted,
        },
    } = formData;
    const { photoRotationEnabled } = listing;
    const isInputFormDisabled = isArchived || isUpdateListingRestricted;
    const isPostingPathAdmin = userUtils.isPostingPathAdmin(userRoles);
    const hasFloorPlans = formData.floorplans.length > 0;
    const hasUnits = formData.units.length > 0;

    return (
        <Spacer paddingX={0} className="EditListingPage-NotEditable-Container">
            {(isCommunity || isFeed) && formData.active && (
                <ListingStatus
                    canUpdateListing={canUpdateListing}
                    syndication={syndication}
                    isCommunity={isCommunity}
                    listing={listing}
                    address={address}
                    cityStateZip={cityStateZip}
                />
            )}
            <ListingTour
                tour={formData.tour}
                tourType={isCommunity ? 'amenity' : 'singleFamily'}
                isDisabled={isInputFormDisabled}
                updateStatusMessage={updateStatusMessage}
                updateFormData={updateFormData}
                formData={formData}
            />
            {(hasFloorPlans || hasUnits) && (
                <React.Fragment>
                    <StyledHR />
                    {hasFloorPlans && (
                        <FloorplansMF
                            canEditTourOverwrite={!isInputFormDisabled}
                            errorObj={errorObj}
                            formData={formData}
                            getActiveFloorplanOrUnitCount={getActiveFloorplanOrUnitCount}
                            isAddingUnit={isAddingUnit}
                            isInputFormDisabled={true}
                            isListingPhotoProcessing={isListingPhotoProcessing}
                            isMobile={isScreenXS || isScreenSM}
                            isPostingPathAdmin={isPostingPathAdmin}
                            photoRotationEnabled={photoRotationEnabled}
                            propertyId={formData.propertyId}
                            saveFloorplanData={saveFloorplanData}
                            updateErrorObj={updateErrorObj}
                            updateFormData={updateFormData}
                            updateListingPhotoProcessingStatus={updateListingPhotoProcessingStatus}
                            updateOnFocus={updateOnFocus}
                            updateParentFloorplanPrice={updateParentFloorplanPrice}
                            updateStatusMessage={updateStatusMessage}
                            validateFloorplan={validateFloorplan}
                            validateFloorplans={validateFloorplans}
                            validateUnit={validateUnit}
                        />
                    )}
                    {hasUnits && (
                        <UnitsSection
                            formData={formData}
                            isMobile={isScreenXS || isScreenSM}
                            isPostingPathAdmin={isPostingPathAdmin}
                            isInputFormDisabled={true}
                            canEditTourOverwrite={!isInputFormDisabled}
                        />
                    )}
                </React.Fragment>
            )}
        </Spacer>
    );
};

const mapStateToProps = state => ({
    userRoles: UserSelectors.makeRoles(state),
    isScreenXS: AppSelectors.makeIsScreenXS(state),
    isScreenSM: AppSelectors.makeIsScreenSM(state),
    user: UserSelectors.makeUser(state),
});


export default connect(mapStateToProps)(NotViewableContent);
